module.exports = __webpack_public_path__ + "static/profile-9915428b6b22a69bfbefd2f3cdac3001.png";